import React, { useEffect, useState } from "react";
import axios from "axios";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

// Import Autoplay module
import { Autoplay, Navigation } from "swiper/modules";

const SERVER_URL = "https://allinoneai-d1a5a1b54c64.herokuapp.com";

const TestimonialSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/testimonials`);
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Failed to load testimonials:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return null;
  if (!data || !data.isActive) return null;

  return (
    <>
      <section className="testimonial-section position-relative py-5 overflow-hidden" style={{ backgroundColor: "#050505" }}>
        {/* Advanced Background Gradients for AI Feel */}
        <div className="position-absolute top-0 start-50 translate-middle-x w-100 h-100 z-n1 pointer-events-none">
            <div className="ambient-glow bg-primary opacity-20" style={{ width: "60vw", height: "60vh", filter: "blur(120px)", borderRadius: "50%", position: "absolute", top: "-20%", left: "-10%" }}></div>
            <div className="ambient-glow bg-info opacity-10" style={{ width: "50vw", height: "50vh", filter: "blur(100px)", borderRadius: "50%", position: "absolute", bottom: "-10%", right: "-10%" }}></div>
            <div className="grid-overlay position-absolute w-100 h-100" style={{ backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)", backgroundSize: "40px 40px", maskImage: "radial-gradient(ellipse at center, black 20%, transparent 80%)", WebkitMaskImage: "radial-gradient(ellipse at center, black 20%, transparent 80%)" }}></div>
        </div>

        <div className="container mt-5 pt-4">
          <div className="text-center mb-5 pb-4 position-relative z-1">
            <div className="section-title">
              <span className="badge rounded-pill px-4 py-2 mb-4 d-inline-flex align-items-center wow fadeInUp shadow-sm" style={{ background: "rgba(99, 102, 241, 0.1)", border: "1px solid rgba(99, 102, 241, 0.3)", color: "#a5b4fc", letterSpacing: "0.1em", fontWeight: "600" }}>
                <i className="fa-solid fa-sparkles me-2"></i> {data.sectionInfo?.subTitle || "POWERED BY AI"}
              </span>
              <h2 className="fw-bolder text-white wow fadeInUp" data-wow-delay=".2s" style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)", lineHeight: "1.1", letterSpacing: "-0.04em" }}>
                {data.sectionInfo?.mainTitle || "Trusted by Visionary Teams"}
              </h2>
              <p className="text-white-50 mt-3 mx-auto" style={{ maxWidth: "600px", fontSize: "1.1rem" }}>
                See how top agencies and creators are scaling their content 10x faster with our text generation engine.
              </p>
            </div>
          </div>

          <div className="marquee-container position-relative mt-5">
            {/* Smooth Edge Fading Masks */}
            <div className="position-absolute top-0 start-0 h-100 z-2 pointer-events-none"></div>
            <div className="position-absolute top-0 end-0 h-100 z-2 pointer-events-none"></div>

            <Swiper
              slidesPerView={1.1}
              spaceBetween={24}
              loop={true}
              speed={800}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              navigation={{
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
              }}
              modules={[Autoplay, Navigation]}
              className="swiper testimonial-marquee pb-5 pt-2 px-2"
              breakpoints={{
                576: { slidesPerView: 1.5 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 2 },
              }}
            >
              <div className="swiper-wrapper linear-transition">
                {data.testimonials?.map((item) => (
                  <SwiperSlide key={item.id} className="h-auto">
                    <div className="premium-testimonial-card h-100 d-flex flex-column position-relative overflow-hidden group">
                      
                      {/* Animated Glow Border */}
                      <div className="animated-border z-0"></div>

                      {/* Card Content Wrapper */}
                      <div className="card-content-wrapper position-relative z-1 d-flex flex-column h-100 p-4 p-md-5 rounded-4" style={{ backgroundColor: "#0c0c12", border: "1px solid rgba(255,255,255,0.04)" }}>
                        
                        {/* Large Quote Mark Background */}
                        <div className="position-absolute text-white" style={{ top: "-10px", left: "15px", fontSize: "8rem", opacity: "0.03", fontFamily: "serif", lineHeight: "1", pointerEvents: "none" }}>"</div>

                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex text-warning" style={{ gap: "4px" }}>
                                {[...Array(5)].map((_, i) => (
                                    <i key={i} className="fa-solid fa-star" style={{ fontSize: "0.9rem" }}></i>
                                ))}
                            </div>
                            <span className="badge rounded-pill small" style={{ background: "rgba(16, 185, 129, 0.1)", color: "#34d399", border: "1px solid rgba(16, 185, 129, 0.2)" }}>
                                <i className="fa-solid fa-bolt-lightning me-1"></i> High Output
                            </span>
                        </div>

                        <p className="flex-grow-1 mb-4 position-relative z-1 text-white" style={{ fontSize: "1.05rem", lineHeight: "1.7", fontWeight: "300", letterSpacing: "0.01em", opacity: "0.85" }}>
                          "{item.quote}"
                        </p>
                        
                        <div className="client-info d-flex align-items-center mt-auto pt-4 position-relative z-1" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                          <div className="client-image me-3 rounded-circle overflow-hidden position-relative" style={{ width: "52px", height: "52px" }}>
                            <div className="position-absolute w-100 h-100 rounded-circle" style={{ border: "2px solid rgba(99, 102, 241, 0.5)", zIndex: "2" }}></div>
                            <img src={item.clientImage} alt={item.clientName} className="img-fluid w-100 h-100 object-fit-cover" />
                          </div>
                          <div className="client-details">
                            <h5 className="text-white mb-1 fw-bold" style={{ fontSize: "0.95rem" }}>{item.clientName}</h5>
                            <span className="text-uppercase" style={{ fontSize: "0.75rem", letterSpacing: "0.1em", background: "linear-gradient(135deg, #a5b4fc, #c4b5fd)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontWeight: "600" }}>
                              {item.clientRole}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </div>
            </Swiper>
            
            {/* Custom Navigation Buttons */}
            <div className="d-flex justify-content-center mt-4 gap-3 position-relative z-3">
              <button className="btn btn-outline-secondary rounded-circle swiper-button-prev-custom d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px', borderColor: 'rgba(255,255,255,0.1)', color: '#fff', background: 'rgba(12, 12, 18, 0.7)', backdropFilter: 'blur(10px)' }}>
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button className="btn btn-outline-secondary rounded-circle swiper-button-next-custom d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px', borderColor: 'rgba(255,255,255,0.1)', color: '#fff', background: 'rgba(12, 12, 18, 0.7)', backdropFilter: 'blur(10px)' }}>
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`


          .premium-testimonial-card {
            border-radius: 1.5rem;
            padding: 2px !important; /* Space for animated border */
            transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            position: relative;
            background-color: transparent;
          }

          .premium-testimonial-card:hover {
            transform: translateY(-8px);
          }

          /* Animated Gradient Border Magic */
          .animated-border {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: linear-gradient(120deg, rgba(255,255,255,0.05), rgba(255,255,255,0.01));
            border-radius: 1.5rem;
            z-index: 0;
            opacity: 0;
            transition: opacity 0.5s ease;
          }

          .premium-testimonial-card:hover .animated-border {
            opacity: 1;
          }

          .premium-testimonial-card::before {
            content: '';
            position: absolute;
            top: -50%; left: -50%; width: 200%; height: 200%;
            background: conic-gradient(transparent, transparent, transparent, #6366f1, #8b5cf6, transparent);
            animation: rotate-border 4s linear infinite;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.4s ease;
            pointer-events: none;
          }

          .premium-testimonial-card:hover::before {
            opacity: 1;
          }

          @keyframes rotate-border {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .card-content-wrapper {
             box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);
          }

          /* Soft glow effect inside the card on hover */
          .card-content-wrapper::after {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: radial-gradient(circle at 50% 0%, rgba(99, 102, 241, 0.08) 0%, transparent 60%);
            opacity: 0;
            transition: opacity 0.5s ease;
            pointer-events: none;
            border-radius: inherit;
          }

          .premium-testimonial-card:hover .card-content-wrapper::after {
            opacity: 1;
          }
        `}</style>
      </section>
    </>
  );
};

export default TestimonialSection;